// define ['baconjs', 'lodash', 'socket.io', 'base/data/BasicLiveChannel'],
// (Bacon, _, io, BasicLiveChannel) ->
import { Bus } from 'baconjs'
// import io from 'socket.io-client'
// import _ from 'lodash'
import BasicLiveChannel from '../BasicLiveChannel'

// const REST_PREFIX = "/api/v1"
const REST_PREFIX = "" // Handled by consumers
const SLASH = "/"
const DEFAULT_METHOD = "GET"

const addPathPrefix = (restPrefix, separator, path) => {
  if (!path || path.length <= 0)  {
    throw Error("Must supply a path")
  }
  const pathPrefix = path[0] !== separator ? restPrefix + separator : restPrefix
  return pathPrefix + path
}

class WorkerSocketRestDispatcher {
  constructor(opts) {
    const worker = opts.worker
    const io = opts.io
    // route incoming rest messages to the correct worker context
    this.domains = {
      ui: new Bus(),
      worker: new Bus()
    }

    // ui messages just get sent to the UI to be handled
    this.domains.ui.onValue((val) => {
      worker.postMessage({
        eventType: 'rest',
        message: val
      })
    })

    // any requests from the UI get forwarded to server
    this.receiver = new Bus()
    this.receiver.onValue(this.send.bind(this))

    this.restChannel = new BasicLiveChannel({
      io: io,
      channelUrl: opts.channelUrl || "/rest",
      eventName: "response",
      onDataChanged: this.handleData.bind(this)
    })
  }

  start() {
    this.restChannel.start()
    this.restChannel.socket.on('reconnect', () => {
      this.domains.ui.push({
        handleReconnect: true
      })
    })
  }

  handleData(data) {
    const spl = data.requestId.split(":")
    const domain = spl && spl != null ? spl[0] : void 0
    if (this.domains[domain]) {
      this.domains[domain].push(data)
    }
  }

  send(data) {
    let eventName = null
    if (data.abort) {
      eventName = 'abort'
    } else {
      data.path = addPathPrefix(REST_PREFIX, SLASH, data.path)
      if (!data.method || data.method == null) {
        data.method = DEFAULT_METHOD
      }
      eventName = 'request'
    }
    this.restChannel.sendData(data, eventName)
  }
}

export default WorkerSocketRestDispatcher
